
import {
    onMounted,
    ref,
    defineAsyncComponent,
 } from 'vue'; 

import usePresentaciones from '@/modules/ventas/composables/usePresentaciones';

export default {
    components: {
        PresentacionEditarComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/PresentacionEditarComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerPresentaciones,
        } = usePresentaciones();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'Nombre', value: 'nombre', sortable: true },
            { text: 'Sigla', value: 'sigla', sortable: true },
            { text: 'Estado', value: 'estado', sortable: true },
            { text: '', value: 'acciones', width: 15 },
        ];

        let presentaciones: any = [];
        const presentacionesFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const presentacionEditarComponentRef = ref();

        onMounted(async() => {
            await buscarPresentaciones();
        });

        const buscarPresentaciones = async () => {
            const resp = await obtenerPresentaciones(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                presentaciones = resp.data;
                presentacionesFiltrados.value = JSON.parse(JSON.stringify(presentaciones));
            }
        }

        const nuevaPresentacion = async () => {
            presentacionEditarComponentRef.value.abrirComponent();
        }

        const editarPresentacion = async (presentacion: any) => {
            presentacionEditarComponentRef.value.abrirComponent(JSON.parse(JSON.stringify(presentacion)));
        }

        const filtrarInformacion = async () => {
            presentacionesFiltrados.value = JSON.parse(JSON.stringify(
                presentaciones.filter(
                    (u: any) => u.nombre.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarEditarPresentacionComponentEmit = async(seGrabo: boolean) => {
            if (seGrabo) {
                await buscarPresentaciones();
            }
        }

        return {
            fitroBusqueda,
            headers,
            textoFiltro,
            presentacionesFiltrados,

            buscarPresentaciones,
            editarPresentacion,
            filtrarInformacion,
            nuevaPresentacion,

            presentacionEditarComponentRef,
            cerrarEditarPresentacionComponentEmit,
        };
    }
}
